export async function ServerRunning () {
    const API = process.env.REACT_APP_API_URL;

    try {
        const res = await fetch(`${API}/ping`, {
            method: "GET",
            cache: "no-store",
            headers: {
                "Cache-Control": "no-cache",
                "Pragma": "no-cache"
            }
        });

        return res.ok;

    } catch {
        return false;
    }
}